import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import { SurveyQuestion } from "../../../types";
import getControlProps from "../helpers/getControlProps";

interface EmailQuestionProps {
  question: SurveyQuestion;
  onChange: any;
  answer: any;
  error: string;
}

class EmailQuestion extends React.Component<EmailQuestionProps, {}> {
  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.props.onChange(this.props.question, e.currentTarget.value);
  };

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <input
          type="email"
          autoComplete="email"
          placeholder={this.props.question.PlaceholderText}
          value={this.props.answer || ""}
          onChange={this.onChange}
          {...getControlProps(this.props.question, this.props.error)}
        />
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default EmailQuestion;
